import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
export const useStyles = makeStyles(
  (theme) => ({
    dropzone: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: theme.spacing(5),
      color: COLORS.gray.gray30,
      border: '1px dashed' + COLORS.gray.gray50,
      borderRadius: theme.shape.borderRadius,
      cursor: 'pointer',
      transition: theme.transitions.create('border-color', {
        duration: theme.transitions.duration.short,
      }),
    },
    activeDropzone: {
      borderColor: COLORS.primary.medium,
    },
    csvIcon: {
      marginBottom: theme.spacing(0.5),
    },
    uploadButton: {
      display: 'flex',
      alignItems: 'center',
      height: 40,
      padding: theme.spacing(1, 2),
      margin: theme.spacing(2, 0),
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: COLORS.primary.silver,
      color: COLORS.primary.default,
      borderRadius: theme.shape.borderRadiusSmall,
    },
    uploadIcon: {
      fontSize: theme.typography.pxToRem(20),
      paddingRight: theme.spacing(0.5),
    },
    uploadedFile: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: theme.spacing(2),
      borderRadius: theme.shape.borderRadiusMedium,
      backgroundColor: COLORS.gray.gray90,
    },
    displayOnly: {
      color: COLORS.gray.gray30,
    },
    leftSide: {
      display: 'flex',
      alignItems: 'center',
      overflow: 'hidden',
    },
    uploadedFileContent: {
      width: '100%',
      marginLeft: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    uploadedFileDetails: {
      display: 'flex',
      color: COLORS.gray.gray30,
      fontWeight: theme.typography.fontWeightRegular,
    },
    fileName: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      paddingRight: theme.spacing(2),
    },
    divider: {
      margin: theme.spacing(0, 0.75),
      color: COLORS.gray.gray60,
    },
    deleteIcon: {
      padding: theme.spacing(0.5),
      borderRadius: theme.shape.borderRadiusSmall,
      cursor: 'pointer',
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.short,
      }),
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
      '&:hover': {
        backgroundColor: COLORS.gray.gray60,
      },
    },
  }),
  {
    name: 'CsvUpload',
  }
);
